import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { useFlashCheck } from '../../../pages/flashcheck/hooks/useFlashCheck';
import {
  Container,
  Header,
  Title,
  Description,
  TabContainer,
  TabContent,
  ContentArea
} from '../../../pages/admin/components/styled';
import SuperAdminTabNavigation, { SuperAdminTabType } from './SuperAdminTabNavigation';
import SystemOverviewTab from './SystemOverviewTab';
import AllCompaniesTab from './AllCompaniesTab';
import PlatformSettingsTab from './PlatformSettingsTab';
import SuperAdminUploadTab from './SuperAdminUploadTab';
import CompanyCreditManagementTab from './CompanyCreditManagementTab';

const SuperAdminPortal: React.FC = () => {
  const [activeTab, setActiveTab] = useState<SuperAdminTabType>('overview');
  const { userData } = useAuth();
  
  const {
    loading,
    error,
    uploadSuccess,
    setUploadSuccess,
    setError,
    loadFiles
  } = useFlashCheck();

  const handleUploadComplete = () => {
    loadFiles(); // Refresh the file list after upload
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <SystemOverviewTab />;
      case 'companies':
        return <AllCompaniesTab />;
      case 'upload':
        return (
          <SuperAdminUploadTab
            loading={loading}
            error={error}
            uploadSuccess={uploadSuccess}
            setUploadSuccess={setUploadSuccess}
            setError={setError}
            loadFiles={loadFiles}
            onUploadComplete={handleUploadComplete}
          />
        );
      case 'credits':
        return <CompanyCreditManagementTab />;
      case 'settings':
        return <PlatformSettingsTab />;
      default:
        return null;
    }
  };

  return (
    <Container>
      <Header>
        <Title>🚀 IntuitionAI Super Admin</Title>
        <Description>
          System-wide management portal for IntuitionAI platform.
          Monitor all companies, users, and system performance.
        </Description>
        <div style={{ marginTop: '12px', fontSize: '0.9rem', color: '#cbd5e1' }}>
          Logged in as: {userData?.email}
        </div>
      </Header>
      
      <TabContainer>
        <SuperAdminTabNavigation
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        
        <TabContent>
          <ContentArea>
            {renderTabContent()}
          </ContentArea>
        </TabContent>
      </TabContainer>
    </Container>
  );
};

export default SuperAdminPortal;
